import { TSTitleCard } from '@/components/shared/card/Card';
import { Icon } from '@/components/shared/icons/Icon';
import { FunctionComponent } from 'react';
import { IconType } from 'react-icons';
import { BsBarChartFill } from 'react-icons/bs';
import { FiCalendar, FiClock } from 'react-icons/fi';
import essStrings from '../../ess/ess.translations';
import { ScheduleSummary } from './scheduleSummary';

type SummaryRowProps = {
  label: string;
  value: string | number;
  icon: IconType;
};

function SummaryRow({ label, value, icon }: SummaryRowProps) {
  return (
    <div className="flex flex-row items-center justify-between pt-2 first:pt-0">
      <div>
        <p className="text-lg">{label}</p>
        <p className="text-2xl font-bold">{value}</p>
      </div>
      <Icon theme="primary" Icon={icon} />
    </div>
  );
}

interface SummaryCardProps {
  summary: ScheduleSummary;
}

const SummaryCard: FunctionComponent<SummaryCardProps> = ({ summary }) => {
  const rows: SummaryRowProps[] = [
    { label: essStrings.monthlySummary.timeWorked, value: summary.timeWorked, icon: FiClock },
    { label: essStrings.monthlySummary.daysWorked, value: summary.daysWorked, icon: BsBarChartFill },
    { label: essStrings.monthlySummary.plannedAbsences, value: summary.plannedAbsences, icon: FiCalendar }
  ];

  return (
    <TSTitleCard title={essStrings.monthlySummary.label} icon={FiCalendar}>
      <div className="flex flex-col lg:flex-row divide-y-2 lg:divide-y-0 lg:divide-x-2 lg:gap-4">
        {rows.map(row => (
          <div key={row.label} className="py-4 lg:py-0 first:pt-0 last:pb-0 lg:flex-1 lg:px-4 lg:first:pl-0">
            <SummaryRow {...row} />
          </div>
        ))}
      </div>
    </TSTitleCard>
  );
};

export default SummaryCard;
